// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IAuthenticateAndCreateSessionRequest {
    'key': string;
    'username': string;
    'password': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IAuthenticateAndCreateSessionRequest>> = [
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "username",
            "baseName": "username",
            "type":     "string"
        },
        {
            "name":     "password",
            "baseName": "password",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return IAuthenticateAndCreateSessionRequest.attributeTypeMap;
    }
}
